import React from "react";
import { SvgBox, SvgBoxProps } from "@govlaunch/web";

export default function AddProjectIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2451 6.75989H12.7541C13.1584 6.75989 13.4982 7.10006 13.4982 7.50398V10.5011H16.4956C16.8999 10.5011 17.2397 10.8412 17.2397 11.2451V12.7541C17.2397 13.1584 16.8999 13.4982 16.4956 13.4982H13.4982V16.4956C13.4982 16.9211 13.1584 17.2397 12.7541 17.2397H11.2451C10.8412 17.2397 10.5011 16.9211 10.5011 16.4956V13.4982H7.50398C7.07888 13.4982 6.75989 13.1584 6.75989 12.7541V11.2451C6.75989 10.8412 7.07883 10.5011 7.50398 10.5011H10.5011V7.50398C10.5011 7.10011 10.8412 6.75989 11.2451 6.75989ZM12.0108 2.25305C17.3884 2.25305 21.7466 6.61087 21.7466 12.01C21.7466 17.3884 17.3884 21.7466 12.0108 21.7466C6.61088 21.7466 2.25305 17.3884 2.25305 12.01C2.25305 6.61087 6.61088 2.25305 12.0108 2.25305ZM24 12.0101C24 5.37797 18.6217 0 12.0108 0C5.37797 0 0 5.37797 0 12.0101C0 18.6217 5.37797 24 12.0108 24C18.6217 24 24 18.6217 24 12.0101Z"
        fill="#3F4A5A"
      />
    </SvgBox>
  );
}
